import {Injectable} from '@angular/core';
import {RestangularModule, Restangular} from 'ngx-restangular'

@Injectable()
export class DesignationMasterService {

  constructor(private restangular:Restangular) {
  }

  getAllDesignations() {
    return this.restangular.all('getAllDesignations');
  }

  designationsMasterCRUD() {
    return this.restangular.all('designationsCRUD');
  }

  designationUD(id) {
    return this.restangular.one('designationsCRUD/' + id);
  }

  public getTemplateEmployeesFormData() {
    return this.restangular.one("getTemplateEmployeesFormData");
  }

  public getAllEmployeesFormData() {
    return this.restangular.one("getAllEmployeesFormData");
  }

  public getUnAssignCourseByDesignation(){
    return this.restangular.one("getUnAssignCourseByDesignation");
  }

  public courseDesignationCRUD(){
    return this.restangular.all('course_designations');
  }

}



// WEBPACK FOOTER //
// /app/src/app/services/designation-master.service.ts